var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.countryIsoCode && _vm.showCountryFlag)?_c('CountryFlag',{attrs:{"iso":_vm.countryIsoCode,"mode":"squared"}}):_vm._e(),(_vm.showCountryName)?_c('span',[_vm._v(_vm._s(_vm.countryName))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }